module.exports = __webpack_public_path__ + "img/apple-app-store.96b852a9.png";